import PageHeader from "../components/headers/PageHeader";
import Banner from "../components/banner/Banner";
import WhatsappBanner from "../components/banner/WhatsappBanner";
import WebProjectCard from "../components/cards/WebProjectCard";
import { React, useEffect } from "react";
import TwoLineTitle from "../components/titles/TwoLineTitle";

const WebAndUIUX = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      name: "Official Website | EMEE Creations",
      category: "Business Website",
      image: "assests/images/portfolio/web/emee-creations.png",
      readmore: "https://emeecreations.com/",
    },
    {
      name: "Official Website | Nipun Furniture",
      category: "E-Commerce Website",
      image: "assests/images/portfolio/web/nipun-furniture.png",
      readmore: "https://nipunfurniturelk.com/",
    },
    {
      name: "Official Website | SL Neurorobotics",
      category: "Academic Publishing Website",
      image: "assests/images/portfolio/web/sl-neurorobotics.jpg",
      readmore: "#",
    },
    {
      name: "Official Website | Sukie Ceylon",
      category: "E-Commerce Website",
      image: "assests/images/portfolio/web/sukie-ceylon-web-01.webp",
      readmore: "http://sukieceylon.lk/",
    },
    {
      name: "Multi Purpose Portfolio",
      category: "Personal Website",
      image: "assests/images/portfolio/web/multipurpose-portfolio.jpg",
      readmore: "https://yasith-eranda.web.app/",
    },
    {
      name: "WebEase | Dynamic Web Solution",
      category: "Business Website",
      image: "assests/images/portfolio/web/web-ease.webp",
      readmore: "#",
    },
    {
      name: "Official Website | Rotaract UWU",
      category: "Organization Website",
      image: "assests/images/portfolio/web/racuwu.jpg",
      readmore: "https://racuwu.lk/",
    },
    {
      name: "Online BoQ Platform",
      category: "Web Application",
      image: "assests/images/portfolio/web/boq-master.jpg",
      readmore: "https://boq-master.web.app/",
    },
  ];

  return (
    <div>
      <PageHeader heading="Web Development" />
      <div className="flex justify-center pt-8">
        <Banner
          url="contact"
          text="Get More Details"
          btn="Contact Me"
          subtext="I'm always open to discussing product design work or partnerships."
        />
      </div>

      <TwoLineTitle
        des="From designing to development, these are some skills I have been working on for the past couple of years."
        main="Web Development"
      />

      <div className="w-full flex flex-col gap-8 px-4 md:px-8 py-4">
        {services.map((service, i) => (
          <WebProjectCard
            key={i}
            name={service.name}
            category={service.category}
            image={service.image}
            readmore={service.readmore}
            reverse={i % 2 !== 0}
          />
        ))}
      </div>

      <div className="flex justify-center py-8">
        <WhatsappBanner />
      </div>
    </div>
  );
};

export default WebAndUIUX;
